import styled from '@emotion/styled'
import { Black } from '@mehilainen/design-system-tokens/colors'
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

const StyledLabel = styled(FormLabel)`
  color: ${Black};
`

interface Props {
  id: string
  label: string
  value?: boolean
  required?: boolean
  onChange(event: React.ChangeEvent<{ name: string; value: boolean | undefined }>): void
}

const FormToggle: React.FC<Props> = ({ id, required, label, value, onChange }) => {
  const { t } = useTranslation()
  const labelId = `${id}-label`

  return (
    <FormControl>
      <StyledLabel required={required} color="primary" id={labelId}>
        {label}
      </StyledLabel>
      <RadioGroup
        row
        aria-labelledby={labelId}
        id={id}
        value={value === undefined ? undefined : value ? 'true' : 'false'}
        onChange={(event, newValue) =>
          onChange({
            target: {
              name: id,
              value: newValue === 'true' ? true : newValue === 'false' ? false : undefined,
            },
          } as unknown as React.ChangeEvent<{ name: string; value: boolean | undefined }>)
        }
      >
        <FormControlLabel
          control={<Radio color="primary" />}
          label={t('common.yes')}
          value="true"
        />
        <FormControlLabel
          control={<Radio color="primary" />}
          label={t('common.no')}
          value="false"
        />
      </RadioGroup>
    </FormControl>
  )
}

export default FormToggle
